import React from 'react';
import API_CONFIG from '../config';

const Card = ({ title, desc, image, link, layout }) => {
  const imageHeight = layout === 'full' ? '100%' : '250px';
  
  return (
    <a
      className="card"
      href={link}
      target="_blank"
      rel="noopener noreferrer"
    >
      {image && (
        <img
          src={image.startsWith('/uploads/') ? API_CONFIG.BASE_URL + image : image}
          alt={title}
          style={{ height: imageHeight }}
        />
      )}
      <div className="card-content">
        <h2>{title}</h2>
        <p>{desc}</p>
      </div>
    </a>
  );
};

export default Card; 